import { EVENT_LOG_MISSION_VIEWED, EventLogDispatcher } from '../../utils/eventLogs/EventLogDispatcher';

class MissionViewedDispatcher {
  static dispatch(_id, _name, _link) {
    //EventLogDispatcher.dispatch(EVENT_LOG_MISSION_VIEWED, { Mission: id }, { name, link });
  }
}

module.exports = MissionViewedDispatcher;
